import React from "react";
import SpecialityFormPage from "../components/specialities/SpecialityFormPage";

const SpecialityCreate = () => <SpecialityFormPage mode="create" />;

export default SpecialityCreate;
